import { render } from "./ui-rating.vue?vue&type=template&id=5212570a"
import script from "./ui-rating.vue?vue&type=script&lang=js"
export * from "./ui-rating.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__